// extracted by mini-css-extract-plugin
export default {"cls1":"VeloModalSheetHeaderTitle-Title_cls1__QFqpD","cls2":"VeloModalSheetHeaderTitle-Title_cls2__Wy5d3 VeloModalSheetHeaderTitle-Title_cls1__QFqpD"};